import { createApi} from "@reduxjs/toolkit/query/react";
import { createBaseQueryWithReauth } from "../utilities/refreshTokenUtility";

export const roleApi = createApi({
  reducerPath: "roleApi",
  
  baseQuery: createBaseQueryWithReauth(`${import.meta.env.VITE_BASE_API_URL}Role/`),

  endpoints: (builder) => ({
    getAllRole: builder.query({
      query: () => ({
        url: "GetRoles",
        method: "GET",
      }),
    }),

    addRole: builder.mutation({
      query: (body) => {
        return {
          url: "AddRole",
          method: "POST",
          body,
        };
      },
    }),

    updateRole: builder.mutation({
      query: (body) => {
        return {
          url: "UpdateRole",
          method: "PUT",
          body,
        };
      },
    }),

    deleteRole: builder.mutation({
      query: (id) => ({
        url: `DeleteRole?id=${id}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useAddRoleMutation,
  useGetAllRoleQuery,
  useUpdateRoleMutation,
  useDeleteRoleMutation,
} = roleApi;

export default roleApi.reducer;
